import { EnrichTransactionInput, Transaction } from "@/types/api"
import http from "@/lib/http/client"

export const enrichTransaction = async (transaction: EnrichTransactionInput): Promise<Transaction> => {
  const res = await http.post(`/transactions`, transaction)
  return res.data
}
